import { makeOperation as r } from "@urql/core";

import { mergeMap as e, fromPromise as t, fromValue as n } from "wonka";

var contextExchange = ({getContext: o}) => ({forward: i}) => a => i(e((e => {
  var i = o(e);
  if ("then" in i) {
    return t(i.then((t => r(e.kind, e, t))));
  } else {
    return n(r(e.kind, e, i));
  }
}))(a));

export { contextExchange };
//# sourceMappingURL=urql-exchange-context.mjs.map
